import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authReducer';
import paymentReducer from './paymentReducer';
import reviewsReducer from './reviewsReducer';
import waitingReducer from './waitingReducer';
import errorReducer from './errorReducer';
import googlePlacesReducer from './googlePlacesReducer';
import reviewRequestReducer from './reviewRequestReducer';
import reviewResponseReducer from './reviewResponseReducer';
import reviewResponsePreferredStyleReducer from './reviewResponsePreferredStyleReducer';
import brandColorReducer from './brandColorReducer';
import templatesReducer from './templatesReducer';
import usersReducer from './usersReducer';
import paymentsReducer from './paymentsReducer';
import userInterfaceReducer from './userInterfaceReducer';
import tagReducer from './tagReducer';
import departmentsReducer from './departmentsReducer';
import typingIndicatorReducer from './typingIndicatorReducer';
import businessGroupReducer from './businessGroupReducer';
import webchatLocationsReducer from './webchatLocationsReducer';
import messageAutomationReducer from './messageAutomationReducer';
import teamsReducer from './teamsReducer';
import browserNotificationsReducer from './browserNotificationsReducer';
import notificationReducer from './notificationReducer';
import folderReducer from './folderReducer';
import templateFoldersReducer from './templateFoldersReducer';
import a2pComplianceReducer from './a2pCompliance';
import webchatReducer from './webchatReducer';
import remindersReducer from './remindersReducer';
import { apiSlice } from '@/slices/apiSlice';
import { activityFeedApi } from '@/slices/activityFeedApi';
import { remindersApi } from '@/slices/remindersApi';
import { apiTokensApi } from '@/slices/apiTokensApi';
import { webhookEndpointApi } from '@/slices/webhookEndpointApi';
import opportunitiesReducer from './opportunitiesReducer';
import formsReducer from './formsReducer';
import sequencesReducer from '@/slices/sequencesSlice';
import aiEmployeeReducer from '@/slices/aiEmployeeSlice';
import pipelineReducer from './pipelineReducer';
import voiceReducer from './voiceReducer';

// Define the shape of the root reducer map
const rootReducerMap = {
	auth: authReducer,
	paymentDetails: paymentReducer,
	reviews: reviewsReducer,
	waiting: waitingReducer,
	error: errorReducer,
	googlePlaces: googlePlacesReducer,
	reviewRequests: reviewRequestReducer,
	reviewResponseTemplates: reviewResponseReducer,
	reviewResponsePreferredStyle: reviewResponsePreferredStyleReducer,
	notification: notificationReducer,
	brandColor: brandColorReducer,
	templates: templatesReducer,
	users: usersReducer,
	payments: paymentsReducer,
	userInterface: userInterfaceReducer,
	tags: tagReducer,
	typingIndicator: typingIndicatorReducer,
	departments: departmentsReducer,
	businessGroup: businessGroupReducer,
	webchatLocations: webchatLocationsReducer,
	messageAutomations: messageAutomationReducer,
	teams: teamsReducer,
	browserNotifications: browserNotificationsReducer,
	folders: folderReducer,
	templateFolders: templateFoldersReducer,
	a2pCompliance: a2pComplianceReducer,
	webchat: webchatReducer,
	reminders: remindersReducer,
	opportunities: opportunitiesReducer,
	forms: formsReducer,
	sequences: sequencesReducer,
	pipeline: pipelineReducer,
	voice: voiceReducer,
	aiEmployee: aiEmployeeReducer,
	[apiSlice.reducerPath]: apiSlice.reducer,
	[activityFeedApi.reducerPath]: activityFeedApi.reducer,
	[remindersApi.reducerPath]: remindersApi.reducer,
	[apiTokensApi.reducerPath]: apiTokensApi.reducer,
	[webhookEndpointApi.reducerPath]: webhookEndpointApi.reducer,
};

const rootReducer = combineReducers(rootReducerMap);

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
